import { app, auth } from '@/api'
export default {
    async sendCustomEmailVerification({state}, {email, displayName, rid = 0}){
        if(!email || !displayName){
            return {
                data: {
                    type: 'error',
                    error: {
                        message: 'No email to verify or no displayName provided.'
                    }
                }
            }
        }
        const sendCustomEmailVerification = app.functions('europe-west1').httpsCallable('sendCustomEmailVerification')
        return await sendCustomEmailVerification({
            email, displayName, rid
        })
    },
    async verifyEmail({state}, {email, hash}){
        if(!email){
            return {
                data: {
                    type: 'error',
                    error: {
                        message: 'No email to verify provided.'
                    }
                }
            }
        }
        const verifyEmail = app.functions('europe-west1').httpsCallable('verifyEmail')
        return await verifyEmail({
            email, hash
        })
    },
    async sendMail({state}, data){
        const sendMail = app.functions('europe-west1').httpsCallable('sendMail')
        return sendMail(data)
    },
    async sendJSONMail({state}, data){
        const sendJSONMail = app.functions('europe-west1').httpsCallable('sendJSONMail')
        return sendJSONMail(data)
    },
    testRequest({state}, millis = 3000){
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve('ready')
            }, 3000);
        })
    }
}